module.exports = __webpack_public_path__ + "static/img/10a.04d4308.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/10a.jpg
// module id = e7OI
// module chunks = 0